import _Model from "./_Model";
import PowerSupply from './PowerSupply';

export default class PowerSupplyGroup extends _Model {
  constructor(json) {
    super(json);
    this.name = PowerSupplyGroup.getOrDefault(json, 'name', null);
    this.powerSupply = PowerSupplyGroup.getMappedOrDefault(json, 'powerSupply', null, data => new PowerSupply(data || {}));
    this.consumption = PowerSupplyGroup.getOrDefault(json, 'consumption', 0);
    this.islandsSlots = PowerSupplyGroup.getMappedOrDefault(json, 'islandsSlots', [], data => (data || []).map(d => d));
  }
}
